import { Fragment, useEffect, useState } from "react";
import { fetchModuleAutocomplete, fetchModuleOptionList } from "../reducers/commonSlice";
import { useTranslation } from "react-i18next";

export function SmallForeignField(props) {
    const { config, isFilter, prefix, formik, defaultValue } = props;

    const [options, setOptions] = useState([]);

    const { t } = useTranslation();

    const handleChange = (evt) => {
        const value = evt.target.value;

        if (value) {
            if (formik) formik.setFieldValue(config.dbname, value);
            if (config.onChange) {
                config.onChange(config.dbname, value);
            }
        }
    }

    useEffect(() => {
        async function fetchData() {
            const response = await fetchModuleOptionList(config.foreign.table, config.foreign.filters);
            setOptions(response[config.foreign.table]);
        }
        fetchData();
    }, []);

    return (
        <div className="mb-3 row" key={`${isFilter ? "filter" : "form"}_${prefix}_${config.dbname}`}>

            <label htmlFor={`${isFilter ? "ffilter" : "fform"}_${prefix}_${config.dbname}`} className="col-md-3 col-form-label">{config.label}</label>
            <div className="col-md-9">
                <select
                    className="form-select"
                    id={`${isFilter ? "ffilter" : "fform"}_${prefix}_${config.dbname}`}
                    placeholder="Type to search..."
                    onChange={handleChange}
                    value={defaultValue || (formik?.values && formik?.values[config.dbname]) || ''}
                >
                    <option value={null}>{t('select')}</option>
                    {
                        options?.map(fo => (
                            <option value={fo.id} key={`${isFilter ? "ffilter" : "fform"}_${prefix}_${config.dbname}_{fo.id}`}>{fo.label}</option>
                        ))
                    }
                </select>
            </div>
        </div>
    );
}

export function LargeForeignField(props) {
    const { config, isFilter, prefix, formik, defaultValue } = props;

    const [options, setOptions] = useState([]);
    const [cachedOptions, setCachedOptions] = useState([]);
    const [value, setValue] = useState(defaultValue);
    const [cachedValue, setCachedValue] = useState(null);
    let loading = false;

    useEffect(() => {
        window.$(`#${isFilter ? "ffilter" : "fform"}_${prefix}_${config.dbname}_options`).on('input', function () {
            var val = window.$(`#${isFilter ? "ffilter" : "fform"}_${prefix}_${config.dbname}_options`).val();
            alert(val);
        });
    }, []);

    const inputChange = async (evt) => {
        const value = evt.target.value;
        setValue(value);
        if (value.length < 3) return;
        if (value.length === 3 && value != cachedValue) {
            setCachedValue(value);
            loading = true;
            fetchModuleAutocomplete(config.foreign.table, value, config.foreign.filters)
                .then((response) => {
                    if (response) {
                        setCachedOptions(response[config.foreign.table]);
                        setOptions(response[config.foreign.table]);
                    }
                    loading = false;
                });
        } else {
            const filteredOptions = cachedOptions.filter(co => co.label.toLowerCase().includes(value));
            setOptions(filteredOptions);
        }

        const selectedOption = cachedOptions.find(co => co.label == value);
        if (selectedOption) {
            if (formik) {
                formik.setFieldValue(config.dbname, selectedOption.id || "");
                formik.setFieldValue(config.foreign.dbname, selectedOption.label || "");
            }

            if (config.onChange) {
                config.onChange(config.dbname, selectedOption.id || "", value);
            }
            setValue(null);
        }
    }

    const resetChange = async (evt, value) => {
        setValue("");
    }

    return (
        <div className="mb-3 row" key={`${isFilter ? "filter" : "form"}_${prefix}_${config.dbname}`}>

            <label htmlFor={`${isFilter ? "ffilter" : "fform"}_${prefix}_${config.dbname}`} className="col-md-3 col-form-label">{config.label}</label>
            <div className="col-md-9">
                <input
                    className="form-control"
                    autocomplete="off"
                    list={`${isFilter ? "ffilter" : "fform"}_${prefix}_${config.dbname}_options`}
                    id={`${isFilter ? "ffilter" : "fform"}_${prefix}_${config.dbname}`}
                    placeholder="Type to search..."
                    //onChange={inputChange}
                    onInput={inputChange}
                    value={value !== null ? value : (formik?.values && formik?.values[config.foreign.dbname]) || ''}
                />
                <datalist id={`${isFilter ? "ffilter" : "fform"}_${prefix}_${config.dbname}_options`}>
                    {
                        options?.map(fo => (
                            <option key={`filter_option_${fo.label}`} value={fo.value} >{fo.label}</option>
                        ))
                    }
                </datalist>
            </div>
        </div>
    );
}

function ForeignField(props) {
    const { config, formik, prefix, isFilter, sended } = props;

    return (
        <div>
            {
                config.foreign.type === 'large' &&
                <LargeForeignField
                    config={config}
                    formik={formik}
                    prefix={prefix}
                    isFilter={isFilter}
                    sended={sended}
                />
            }
            {
                config.foreign.type === 'small' &&
                <SmallForeignField config={config}
                    formik={formik}
                    prefix={prefix}
                    isFilter={isFilter}
                    sended={sended}

                />
            }
        </div>
    );
}

export default ForeignField;